import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const ErrorMessage = ({ message, isBold }) => (
  <S.ErrorMessage isBold={isBold}>{message}</S.ErrorMessage>
);

export default ErrorMessage;

ErrorMessage.defaultProps = {
  isBold: true,
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  isBold: PropTypes.bool,
};
